<template>
  <!-- EDITACE ZARIZENI NA DETAILU ZARIZENI -->
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <!-- kvůli zanořeným modalům pro transformační funkce potřebuju z-index 0 vždy -->
    <div
      v-if="editedDevice"
      :class="{
        opened: opened.indexOf('editDevice') >= 0,
        'last-active': opened.indexOf('editDevice') == opened.length - 1
      }"
      class="side-box__inner"
      style="z-index: 0"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZarizeni") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ device.custDeviceName }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.device" class="text-danger">
          {{ errors.device }}
        </div>
        <div class="my-4">
          <a
            :class="{ opened: infoOpened }"
            class="atom-form-group__toggler"
            @click="infoOpened = infoOpened ? false : true"
          >
            {{ $t("vaseInformaceOZarizeni") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: infoOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                {{ $t("nazevZarizeni") }}
              </span>
              <div
                :class="{
                  'has-error': error.custDeviceName
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!editedDevice.custDeviceName" class="placeholder">
                  {{ $t("zadejteNazevZarizeni") }}
                </span>
                <input
                  v-model="editedDevice.custDeviceName"
                  autofocus
                  class="w-100"
                  maxlength="32"
                  placeholder=""
                  type="text"
                  @blur="validateCustDeviceName()"
                  @click="changedEvent"
                />
              </div>
            </div>

            <FormSelect
              :info-text="'info_import_spustitZarizeniDoRezimu'"
              :info-tooltip="'tooltip_import_spustitZarizeniDoRezimu'"
              :items="stateOptions"
              :label="$t('prepnoutDoRezimu')"
              :value="
                selectedState
                  ? stateOptions.find((op) => op.value === selectedState)
                  : stateOptions.find((op) => op.statusText === editedDevice.status)
              "
              class="mb-3"
              item-text="text"
              item-value="value"
              side-box
              @change="
                stateOptions.find((op) => op.value === $event.value).statusText !== editedDevice.status
                  ? (selectedState = $event.value)
                  : (selectedState = '')
              "
            />

            <div class="d-flex side-box__row align-items-start mt-4">
              <span class="side-box__content__label mt-sm-5 pt-4 mt-2">
                {{ $t("CONNECTED_TO_DATA_FLOW") }}
              </span>
              <div
                class="w-100 side-box__content__input side-box__content__input--large border-top ml-3 pt-4 border-top"
              >
                <form-select
                  v-if="selectedDataFlowList.length < 2"
                  :custom-action-text="$t('CREATE_NEW_DATA_FLOW')"
                  :has-error="false"
                  :items="loadedGroups"
                  :placeholder="$t('DEVICE_DATA_FLOW_SELECT_PLACEHOLDER')"
                  :value="selectedDataFlowList[0]"
                  class="mb-4"
                  item-subtext="technology"
                  item-text="deviceGroupName"
                  item-value="deviceGroupId"
                  label=""
                  @change="handleDataFlowChanged($event, false)"
                  @customActionClicked="
                    $router.push({
                      name: 'dataFlowNew',
                      params: $router.params
                    })
                  "
                  @mouseup="handleDataFlowSelectClick"
                />
                <form-select-multiple
                  v-else
                  :custom-action-text="$t('CREATE_NEW_DATA_FLOW')"
                  :has-error="false"
                  :items="loadedGroups"
                  :placeholder="$t('DEVICE_DATA_FLOW_SELECT_PLACEHOLDER')"
                  :value="selectedDataFlowList"
                  class="mb-4"
                  item-subtext="technology"
                  item-text="deviceGroupName"
                  item-value="deviceGroupId"
                  label=""
                  @change="handleDataFlowChanged($event, true)"
                  @customActionClicked="
                    $router.push({
                      name: 'dataFlowNew',
                      params: $router.params
                    })
                  "
                />
              </div>
            </div>

            <div class="d-flex side-box__row align-items-start mt-4">
              <span class="side-box__content__label">
                {{ $t("TRANSFORMATION_FUNCTION") }}
              </span>
              <div v-if="!isTFLoading" class="w-100 side-box__content__input side-box__content__input--large ml-3">
                <FormSelect
                  clearable
                  class="mb-4"
                  :has-error="false"
                  item-text="label"
                  item-value="transformationId"
                  item-subtext="description"
                  :items="loadedTransforms ?? []"
                  :placeholder="$t('noTransformFunction')"
                  label=""
                  :value="loadedTransforms?.find((tf) => tf.transformationId === editedDevice.transformationId)"
                  @change="editedDevice.transformationId = $event.transformationId"
                  @clear="editedDevice.transformationId = null"
                />
              </div>
              <Loader v-else class="w-100 side-box__content__input side-box__content__input--large ml-3" />
            </div>

            <div class="my-4">
              <div class="side-box__row d-flex align-items-center">
                <span class="side-box__content__label" />
                <div class="side-box__content__input ml-3 pb-3 border-top mt-1" />
              </div>
              <user-attributes-field
                v-if="editedDevice.attributes"
                :attributes="editedDevice.attributes"
                @change="userAttributesChanged"
              />

              <!--/div-->
            </div>
            <form-select-multiple
              :items="
                allTags.map((tag) => {
                  return { text: tag }
                })
              "
              :label="$t('pridatTagy')"
              :placeholder="$t('vyberteTagZeSeznamu')"
              :value="selectedTags"
              class="mx-auto mt-3"
              item-text="text"
              item-value="text"
              side-box
              @change="selectedTags = $event"
            />

            <div class="side-box__row d-flex align-items-center">
              <span class="side-box__content__label" />
              <div class="side-box__content__input ml-3 pb-3 border-top mt-4" />
            </div>
            <HwDeviceField
              side-box
              technology="LORA"
              :value="editedDevice.hwDeviceId"
              :should-decode-payload-init="editedDevice.payloadDecode"
              @change="editedDevice.hwDeviceId = $event"
              @payload-decode-changed="editedDevice.payloadDecode = $event"
            />
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: servicesLimitsOpened }"
            class="atom-form-group__toggler"
            @click="servicesLimitsOpened = servicesLimitsOpened ? false : true"
          >
            {{ $t("sluzbaALimity") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: servicesLimitsOpened }" class="atom-form-group__content">
            <form-select
              :items="services"
              :label="$t('sluzba')"
              :value="selectedService"
              item-subtext="custServiceId"
              item-text="tarifName"
              item-value="custServiceId"
              side-box
              @change="selectedService = $event"
            />
            <div class="side-box__content__input custom-control__select disabled-with-result mx-auto mt-1">
              <service-limits v-if="selectedService" :service="selectedService" />
              <p class="mt-3">
                {{ $t("sluzbuMuzeteZmenit") }}
              </p>
            </div>
          </div>
        </div>
        <div class="my-4 text-center">
          <a
            :class="{ opened: activateOpened }"
            class="atom-form-group__toggler"
            @click="activateOpened = activateOpened ? false : true"
          >
            {{ $t("aktivacniAIdentifikacniUdaje") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: activateOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                {{ $t("zpusobAktivace") }}
              </span>
              <div
                v-if="editedDevice.parameters"
                :class="{
                  'has-error': errors.device && !editedDevice.parameters.devicetype
                }"
                class="side-box__content__input custom-control__custom-input disabled ml-3"
                disabled
              >
                <span v-if="!editedDevice.parameters.devicetype" class="placeholder">
                  {{ $t("zpusobAktivace") }}
                </span>
                <input
                  v-model="editedDevice.parameters.devicetype"
                  autofocus
                  class="w-100"
                  disabled
                  placeholder=""
                  type="text"
                />
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                <p class="m-0">Device EUI</p>
                <p class="small gray-text m-0">
                  {{ $t("identifikatorZarizeni") }}
                </p>
              </span>
              <div
                :class="{
                  'has-error': errors.device && !editedDevice.deviceId
                }"
                class="side-box__content__input custom-control__custom-input disabled ml-3"
              >
                <span v-if="!editedDevice.deviceId" class="placeholder">
                  {{ $t("zpusobAktivace") }}
                </span>
                <input v-model="editedDevice.deviceId" autofocus class="w-100" disabled placeholder="" type="text" />
              </div>
            </div>
            <!--
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label"
                ><p class="m-0">DevAddr</p>
                <p class="small gray-text m-0">
                  {{ $t("adresaZarizeni") }}
                </p></span
              >
              <div
                class="side-box__content__input custom-control__custom-input disabled ml-3"
                :class="{
                  'has-error': errors.device && !editedDevice.deviceId
                }"
              >
                <span v-if="!editedDevice.deviceId" class="placeholder">{{
                  $t("zpusobAktivace")
                }}</span>
                <input
                  type="text"
                  class="w-100"
                  v-model="editedDevice.deviceId"
                  placeholder=""
                  autofocus
                  disabled
                />
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label gray-text-light"
                ><p class="m-0">NwkSKey</p>
                <p class="small gray-text-light m-0">
                  {{ $t("sitovySifrovaciKlic") }}
                </p></span
              >
              <div
                class="side-box__content__input custom-control__custom-input disabled ml-3"
              >
                <span class="placeholder d-none">{{
                  $t("sitovySifrovaciKlic")
                }}</span>
                <input
                  type="text"
                  class="w-100"
                  placeholder=""
                  autofocus
                  value="********"
                  disabled
                />
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label gray-text-light"
                ><p class="m-0">AppKey</p>
                <p class="small gray-text-light m-0">
                  {{ $t("aplikacniSifrovaciKlic") }}
                </p></span
              >
              <div
                class="side-box__content__input custom-control__custom-input disabled ml-3"
              >
                <span class="placeholder d-none">{{
                  $t("aplikacniSifrovaciKlic")
                }}</span>
                <input
                  type="text"
                  class="w-100"
                  placeholder=""
                  autofocus
                  value="********"
                  disabled
                />
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
    <save-confirmation-modal
      :opened="openedEndpointConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointConfirmation"
      @no="closeBox('editDevice')"
      @yes="runEdit()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            closeBox('editDevice')
            openedError = false
          }
        "
      />
    </div>
    <div v-if="errorsToTranslate1.length > 0">
      <error-modal :centered="true" :errors="errorsToTranslate1" :opened="openedError1" @close="openedError1 = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import ServiceLimits from "@/components/boxes/serviceLimits.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import UserAttributesField from "../../devices/userAttributesField.vue"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"
import HwDeviceField from "@/components/devices/partials/HwDeviceField.vue"
import Loader from "@/components/loader.vue"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"

export default {
  directives: {},
  components: {
    Loader,
    HwDeviceField,
    FormSelect,
    FormSelectMultiple,
    "save-confirmation-modal": SaveConfirmationModal,
    "error-modal": ErrorModal,
    "service-limits": ServiceLimits,
    UserAttributesField
  },
  props: {
    tags: Array,
    reloadAttributes: Boolean,
    opened: Array,
    device: Object
  },
  setup() {
    const projectStore = useProjectStore()
    const authStore = useAuthStore()
    const tfStore = useTransformationFunctionsStore()

    return { projectStore, authStore, tfStore }
  },
  data: () => ({
    changed: false,
    protocolOpened: false,
    loadedGroups: [],
    selectedGroups: [],
    groupsToUnappend: [],
    groupsOpened: false,
    parametersTagsOpened: false,
    selectedParameters: [],
    selectedEndpointTags: [],
    selectedGroupTags: [],
    groupTags: [],
    writtenEndpointTags: "",
    writtenGroupTags: "",
    protocol: "",
    newGroup: {
      projectId: "",
      deviceGroupName: "",
      deviceGroupDesc: ""
    },
    openedEndpointConfirmation: false,
    openedGroupConfirmation: false,
    errors: {
      device: "",
      parameters: "",
      group: ""
    },
    deviceAdrSelector: "",
    selectGroupVisible: false,
    statusOpened: false,
    selectedState: "",
    tagsOpened: false,
    tagsReadOnly: ["geolocation"], // array of readonly tags, that cannot be removed by user
    selectedTags: [],
    writtenTags: "",
    servicesLimitsOpened: false,
    service: {},
    infoOpened: true,
    activateOpened: false,
    rxwOpened: false,
    devclassOpened: false,
    seqrelaxOpened: false,
    actualGroups: [],
    previousParameters: {},
    lastDevice: {},
    newParameters: {},
    newParameter: {
      name: "",
      type: "text",
      value: ""
    },
    parameterTypeOpened: false,
    openedParamConfirmation: false,
    devAdrParamOpened: false,
    devFixAdrParamOpened: false,
    devRangeMinAdrParamOpened: false,
    devRangeMaxAdrParamOpened: false,
    selectedService: {},
    loadedService: false,
    openedError: false,
    errorsToTranslate: [],
    openedError1: false,
    errorsToTranslate1: [],
    error: {
      custDeviceName: false
    },
    loadedTransforms: [],
    selectedDataFlowList: [],
    userAttributes: [],
    hiddenTags: [],
    editedDevice: {}
  }),
  computed: {
    transformationFunctionList() {
      return this.tfStore.list
    },
    isTFLoading() {
      return this.tfStore.isLoading
    },
    project() {
      return this.projectStore.selectedProject
    },
    apiUser() {
      return this.authStore.apiUser
    },
    services() {
      /**
       * we must use only service which is not suspended or discontinued
       */
      return this.$store.getters["services/services"].filter(s => !s.suspended && !s.discontinued && s.productElementId !== 's_iot8681')
    },
    allTags() {
      return this.projectStore.tagList
    },
    devClassOptions() {
      return [
        {
          text: `A - ${this.$t("pouzePriOdesilani")}`,
          value: "A"
        },
        {
          text: `C - ${this.$t("devclassC")}`,
          value: "C"
        }
      ]
    },
    rxWindowOptions() {
      if (this.newParameters.devclass !== "C") {
        return [
          {
            text: "RX1",
            value: "1"
          },
          {
            text: "RX2",
            value: "2"
          }
        ]
      } else {
        return [
          {
            text: "RX2",
            value: "2"
          }
        ]
      }
    },
    seqRelaxOptions() {
      return [
        {
          text: this.$t("kontrolovatSekvenci"),
          value: "false"
        },
        ...(this.device.devicetype !== "OTAA"
          ? [
              {
                text: this.$t("nekontrolovatSekvenci"),
                value: "true"
              }
            ]
          : [])
      ]
    },
    stateOptions() {
      return [
        ...(!this.device.suspended
          ? [
              {
                atomCircleClass: "atom-circle--success",
                text: this.$t("active"),
                value: "A",
                statusText: "active"
              }
            ]
          : [
              {
                atomCircleClass: "atom-circle--warning",
                text: this.$t("overLimit"),
                value: "A",
                atomCircleText: "O",
                statusText: "suspended"
              }
            ]),
        {
          atomCircleClass: "atom-circle--gray",
          text: this.$t("Standby"),
          value: "S",
          statusText: "standby"
        },
        ...(this.editedDevice.preregistration
          ? [
              {
                atomCircleClass: "atom-circle--warning",
                text: this.$t("PREDREGISTRACE"),
                value: "P",
                statusText: "preregistration"
              }
            ]
          : [])
      ]
    }
  },
  watch: {
    project() {
      this.loadGroups()
      this.setProject()
      this.loadService()
      this.loadTransforms()
    },
    writtenEndpointTags() {
      this.createTagsArray()
    },
    reloadAttributes() {
      if (this.reloadAttributes == true) {
        this.groupsToUnappend = []
        this.selectedGroups = []

        if (this.device != {} && this.device != undefined) {
          this.loadGroups()
          this.setProject()
          this.setActualTags()
          this.loadService()
          this.setActualGroups()
          this.selectedState = ""
          this.$store.dispatch("services/getServices")
          this.previousParameters = Object.assign({}, this.device.parameters)
          this.newParameters = Object.assign({}, this.device.parameters)
        }
        this.setAdrSelector()
      }
    },
    device() {
      if (this.device != {} && this.device != undefined) {
        this.editedDevice = Object.assign({}, this.device)
        this.groupsToUnappend = []
        this.selectedGroups = []
        this.loadGroups()
        this.loadTransforms()
        this.setProject()
        this.setActualTags()
        this.loadService()
        this.setActualGroups()
        this.selectedState = ""
        this.$store.dispatch("services/getServices")
        this.previousParameters = Object.assign({}, this.device.parameters)
        this.newParameters = Object.assign({}, this.device.parameters)
        this.setAdrSelector()
        this.selectedDataFlowList = this.device.deviceGroups || []
      }
    },
    "editedDevice.deviceGroups": {
      handler(deviceGroups) {
        this.selectedDataFlowList = deviceGroups || []
      },
      immediate: true
    },
    "newParameters.devclass": {
      handler(devclass) {
        if (devclass === "C") {
          this.newParameters.rxw = "2"
        }
      },
      immediate: true
    }
  },
  async mounted() {
    if (this.device != {} && this.device != undefined) {
      console.log("edit.vue mounted", this.device)
      this.editedDevice = Object.assign({}, this.device)
      this.groupsToUnappend = []
      this.selectedGroups = []
      this.loadGroups()
      this.loadTransforms()
      this.setProject()
      this.loadService()
      this.setActualGroups()
      await this.projectStore.getAllTags(this.project.projectId)
      this.setActualTags()
      this.selectedState = ""
      this.$store.dispatch("services/getServices")
      this.previousParameters = Object.assign({}, this.device.parameters)
      this.newParameters = Object.assign({}, this.device.parameters)
      this.setAdrSelector()

      this.oldGroups = this.device.deviceGroups
    }
  },
  methods: {
    getTranformationFunctionList() {
      return this.tfStore.getList()
    },
    setAdrSelector() {
      if (this.newParameters.adrFix != "" && this.newParameters.adrFix != null) {
        this.deviceAdrSelector = "fix"
      } else if (this.newParameters.adrMin >= 0 && this.newParameters.adrMax >= 0) {
        this.deviceAdrSelector = "range"
      } else {
        this.deviceAdrSelector = ""
      }
      console.log("deviceAdrSelector", this.deviceAdrSelector)
    },
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      console.log(box)
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else if (box == "newParameter") {
        this.errors.group = ""
        this.errors.parameters = ""
        this.$emit("closeBox", box)
      } else if (box == "editDevice") {
        this.resetValues()
        this.$emit("closeBox", box)
      } else {
        //this.resetValues();
        this.errors.group = ""
        this.errors.parameters = ""

        this.$emit("closeBox", box)
      }
    },
    closeStatus() {
      if (this.statusOpened) {
        this.statusOpened = false
      }
    },
    closeGroups() {
      if (this.groupsOpened) {
        this.groupsOpened = false
      }
    },
    closeTags() {
      if (this.tagsOpened) {
        this.tagsOpened = false
      }
    },
    setActualGroups() {
      if (this.editedDevice.deviceGroups) {
        this.actualGroups = this.editedDevice.deviceGroups.concat()
      }
    },
    setProject() {
      this.newGroup.projectId = this.project.projectId
    },
    setActualTags() {
      if (this.editedDevice.tags) {
        this.selectedTags = this.editedDevice.tags
          .concat()
          .filter((tag) => this.allTags.includes(tag))
          .map((tag) => {
            return { text: tag }
          })
        this.hiddenTags = this.editedDevice.tags
          .concat()
          .filter((tag) => !this.allTags.includes(tag))
          .map((tag) => {
            return { text: tag }
          })
      }
    },
    addWrittenTag() {
      console.log("addWrittenTag()")

      let written = this.writtenTags
      if (this.writtenTags.length > 0) {
        console.log("this.writtenTags.length > 0")
        this.selectedTags.push(written)
        //this.tags.push(written);
        console.log("this.selectedTags.push(written);")
        console.log(this.selectedTags)
        this.writtenTags = ""
      }
    },
    clearGroup() {
      this.newGroup = {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      }
      this.setProject()
    },
    showWaiting() {
      console.log("showWaiting")
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
    },
    hideWaiting() {
      this.$store.commit("modals/setWaitingLoader", "")
    },
    async runEdit() {
      this.errorsToTranslate = []

      if (!this.validateCustDeviceName()) {
        return
      }

      this.showWaiting()

      let editDevice = await this.editDevice()
      let editTags = await this.editTags()
      let editGroups = await this.editGroups()
      let editStatus = await this.setStatus()
      let editAttributes = await this.editAttributes()
      let editService = await this.editService()

      if (editDevice && editTags && editGroups && editStatus && editService && editAttributes) {
        this.hideWaiting()
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
          this.$emit("reloadItems")
          this.$emit("updateItems")
        } else {
          this.$emit("reloadItems")
          this.$emit("updateItems")
          this.$emit("closeBox", "editDevice")
        }
      }
    },
    async setStatus() {
      if (this.selectedState != "") {
        if (this.selectedState == "A" || this.selectedState == "P") {
          let action = "enable"
          if (this.editedDevice.status == "preregistration" && this.editedDevice.enabled == true) {
            action = "activate"
          }
          return axios
            .post(process.env.VUE_APP_API + "/lora/devices/" + this.editedDevice.deviceId + "/" + action, {})
            .then(() => {
              this.editedDevice.enabled = true
              return true
            })
            .catch((error) => {
              this.errorsToTranslate.push(error.data)
              return true
            })
        } else if (this.selectedState == "S") {
          return axios
            .delete(process.env.VUE_APP_API + "/lora/devices/" + this.editedDevice.deviceId + "/enable", {})
            .then(() => {
              this.editedDevice.enabled = false
              return true
            })
            .catch((error) => {
              this.errorsToTranslate.push(error.data)
              return true
            })
        }
        return true
      } else {
        return true
      }
    },
    async editTags() {
      return axios
        .put(
          process.env.VUE_APP_API + "/lora/devices/" + this.editedDevice.deviceId + "/tags",
          this.selectedTags.concat(this.hiddenTags).map((tag) => tag.text),
          {}
        )
        .then(() => {
          this.editedDevice.tags = this.selectedTags.concat(this.hiddenTags)
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          return true
        })
    },
    async getServices() {
      this.services = true
      let servicesOveview = await this.$store.dispatch("services/getServices")
      if (servicesOveview) {
        this.services
      }
    },
    async editService() {
      console.log("editService()")
      return axios
        .post(
          process.env.VUE_APP_API +
            "/services/" +
            this.selectedService.custServiceId +
            "/devices/lora/" +
            this.editedDevice.deviceId +
            "/assign"
        )
        .then((result) => {
          console.log(result)
          if (result.data.status == "success") {
            console.log("new custServiceId")
            console.log(this.selectedService.custServiceI)
            this.device.custServiceId = this.selectedService.custServiceId
            this.$store.dispatch("services/getServices")
          }
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          return true
        })
    },
    async editAttributes() {
      let attributes = this.userAttributes.reduce((acc, { title, value }) => {
        acc[title] = value
        return acc
      }, {})

      return axios
        .put(process.env.VUE_APP_API + "/lora/devices/" + this.editedDevice.deviceId + "/attributes", attributes, {})
        .then(() => {
          this.editedDevice.attributes = attributes
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          return true
        })
    },
    async editDevice() {
      if (this.editedDevice.custDeviceName) {
        return axios
          .put(process.env.VUE_APP_API + "/lora/devices/" + this.editedDevice.deviceId, this.editedDevice, {})
          .then(() => {
            return true
          })
          .catch((error) => {
            this.errorsToTranslate.push(error.data.errors)
            return true
          })
      } else {
        this.errors.device = this.$t("fillAllFieldsError")
      }
    },
    async appendGroups() {
      let deviceId = this.editedDevice.deviceId

      let counterPost = 0
      let edited = this.editedDevice
      this.device.deviceGroups.forEach((group) => {
        return axios
          .post(
            process.env.VUE_APP_API + "/device-groups/" + group.deviceGroupId + "/devices/lora/" + deviceId + "/assign",
            {},
            {}
          )
          .then(() => {
            counterPost++
            if (edited.deviceGroups.findIndex((x) => x.deviceGroupId == group.deviceGroupId) == -1) {
              edited.deviceGroups.push(group)
            }

            if (counterPost == this.selectedGroups.length) {
              return true
            }
          })
          .catch((error) => {
            this.errorsToTranslate.push(error.data)
            counterPost++
            if (counterPost == this.selectedGroups.length) {
              return true
            }
          })
      })
    },
    async unappendGroups() {
      let deviceId = this.editedDevice.deviceId

      let counterPost = 0
      let edited = this.editedDevice
      this.oldGroups.forEach((unappendGroup) => {
        return axios
          .delete(
            process.env.VUE_APP_API +
              "/device-groups/" +
              unappendGroup.deviceGroupId +
              "/devices/lora/" +
              deviceId +
              "/assign"
          )
          .then(() => {
            counterPost++
            edited.deviceGroups.splice(edited.deviceGroups.indexOf(unappendGroup), 1)
            if (counterPost == this.unappendGroups.length) {
              return true
            }
          })
          .catch((error) => {
            this.errorsToTranslate.push(error.data)
            counterPost++
            if (counterPost == this.unappendGroups.length) {
              return true
            }
          })
      })
    },
    async editGroups() {
      const selectedIds = this.selectedDataFlowList.map((group) => group.deviceGroupId)
      const previousIds = this.device.deviceGroups.map((group) => group.deviceGroupId)

      for (const group of this.device.deviceGroups) {
        if (selectedIds.includes(group.deviceGroupId)) {
          continue
        }

        try {
          await axios.delete(
            `${process.env.VUE_APP_API}/device-groups/${group.deviceGroupId}/devices/lora/${this.editedDevice.deviceId}/assign`,
            {}
          )
        } catch (e) {
          this.errorsToTranslate.push(e.data)
        }
      }

      for (const group of this.selectedDataFlowList) {
        if (previousIds.includes(group.deviceGroupId)) {
          continue
        }

        try {
          await axios.post(
            `${process.env.VUE_APP_API}/device-groups/${group.deviceGroupId}/devices/lora/${this.editedDevice.deviceId}/assign`,
            {}
          )
        } catch (e) {
          this.errorsToTranslate.push(e.data)
        }
      }

      return true
    },
    handleTransformChanged(transform) {
      this.editedDevice.transformationId = transform.transformationId
    },
    loadGroups() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/device-groups?projectId[eq]=" +
            this.project.projectId +
            "&limit=1000&sort=%2BdeviceGroupName",
          {}
        )
        .then((result) => {
          this.loadedGroups = result.data.data.map((group) => ({
            ...group,
            technology: group.technology ?? group.tags.includes("hidden_LORA") ? "LORA" : "MQTT"
          }))
          this.projectStore.getAllTags(this.project.projectId)
        })
        .catch(() => {})
    },
    loadService() {
      this.loadedService = false
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.editedDevice.custServiceId, {})
        .then((result) => {
          this.service = result.data.data
          this.selectedService = result.data.data
          this.loadedService = true
        })
        .catch(() => {})
    },
    resetValues() {
      this.protocolOpened = false
      this.groupsOpened = false
      this.parametersTagsOpened = false
      this.tagsOpened = false
      this.errors.device = ""
      this.selectedState = ""
      this.actualGroups = []
      this.selectedGroups = []
      this.groupsToUnappend = []
      this.loadedGroups = []

      this.newParameters = {}
    },
    addRemoveGroup(group) {
      if (this.selectedGroups.indexOf(group) == -1) {
        this.selectedGroups.push(group)
      } else {
        this.selectedGroups.splice(this.selectedGroups.indexOf(group), 1)
      }
    },
    unappendGroup(group) {
      this.groupsToUnappend.push(group)
      this.actualGroups.splice(this.actualGroups.indexOf(group), 1)
      this.statusOpened = true
      this.statusOpened = false
    },
    addRemoveParameter(parameter) {
      if (this.selectedParameters.indexOf(parameter) == -1) {
        this.selectedParameters.push(parameter)
      } else {
        this.selectedParameters.splice(this.selectedParameters.indexOf(parameter), 1)
      }
    },
    createTagsArray() {
      let written = this.writtenEndpointTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedEndpointTags = selected
    },
    async loadTransforms() {
      let params = {
        "type[eq]": "IN",
        "sort[eq]": "label",
        "subType[eq]": "LORA",
        "projectId[eq]": this.$route.params.projectId
      }
      await this.getTranformationFunctionList(params)
      const projectTransforms = [...this.transformationFunctionList]
      params = {
        "type[eq]": "IN",
        "sort[eq]": "label",
        "subType[eq]": "LORA",
        "public[eq]": true
      }
      await this.getTranformationFunctionList(params)
      this.loadedTransforms = [...projectTransforms, ...this.transformationFunctionList]
    },
    handleDataFlowChanged(value, isMultiple) {
      this.selectedDataFlowList = isMultiple ? value : [value]
    },
    handleDataFlowSelectClick({ value, nativeEvent }) {
      if (nativeEvent.ctrlKey) {
        this.selectedDataFlowList = [...this.selectedDataFlowList, value]
      }
    },
    showAttributes() {},
    toggleEndpointConfirmation() {
      if (this.changed) {
        this.openedEndpointConfirmation = !this.openedEndpointConfirmation
      } else {
        this.openedEndpointConfirmation = false
        this.$emit("closeBox", "editDevice")
      }
    },
    toggleGroupConfirmation() {
      this.openedGroupConfirmation = !this.openedGroupConfirmation
    },
    toggleParamConfirmation() {
      this.openedParamConfirmation = !this.openedParamConfirmation
    },
    validateCustDeviceName() {
      if (!this.editedDevice.custDeviceName) {
        this.error.custDeviceName = true
        return false
      } else {
        this.error.custDeviceName = false
        return true
      }
    },
    userAttributesChanged(newVal) {
      this.userAttributes = newVal
      this.changedEvent()
    }
  }
}
</script>

<style lang="scss" scoped></style>
